import MyScript, { MyScriptModel } from '@/api/external/MyScript'
import { DrawingModel } from '@/models/DrawingModel'

/**
 * 手書き入力変換-文字列
 */
export default class MyScriptText extends MyScript {
  /**
   * 変換処理の実行
   *
   * @param canvasWidth キャンバス幅
   * @param canvasHeight キャンバス高さ
   * @param strokes ストローク情報
   * @returns 変換結果
   */
  public async recognize(
    canvasWidth: number,
    canvasHeight: number,
    strokes: DrawingModel.Stroke[]
  ): Promise<string | null> {
    // キャンバスサイズの更新
    this.canvasWidth = canvasWidth
    this.canvasHeight = canvasHeight

    // リクエストの生成
    const body = this.requestBody(strokes)

    // API実行
    const response = await this.post(this.header, body)

    return response.toString()
  }

  /**
   * リクエスト情報生成
   *
   * @param strokes ストローク情報
   * @returns リクエスト情報
   */
  private requestBody(strokes: DrawingModel.Stroke[]): MyScriptModel.RequestBody {
    // デフォルトのリクエスト生成
    const body = this.defaultBody(strokes)

    // 文字列モード用のデータを追加
    const configuration: MyScriptConfiguration = {
      lang: this.lang,
      text: {
        guides: {
          enable: false,
        },
        smartGuide: true,
        smartGuideFadeOut: {
          enable: false,
          duration: 10000,
        },
        mimeTypes: ['application/x-latex'],
      },
    }
    body.configuration = configuration

    return body
  }
}

/**
 * API実行時の詳細設定情報(文字列用)
 */
type MyScriptConfiguration = MyScriptModel.ConfigurationBase & {
  /** 変換先言語 */
  lang: string
  /** 文字列モード用の設定情報 */
  text: MyScriptConfigurationText
}

/**
 * API実行時の文字列関連の詳細設定情報
 */
interface MyScriptConfigurationText {
  /** guides設定(用途不明) */
  guides: MyScriptConfigurationGuide
  /** smartGuide設定(用途不明) */
  smartGuide: boolean
  /** smartGuideFadeOut設定(用途不明) */
  smartGuideFadeOut: MyScriptConfigurationSmartGuideFadeOut
  /** レスポンスのMIMEタイプ */
  mimeTypes: string[]
}

/**
 * API実行時のguides設定(詳細不明)
 */
interface MyScriptConfigurationGuide {
  /** フラグ */
  enable: boolean
}

/**
 * API実行時のsmartGuideFadeOut設定(詳細不明)
 */
interface MyScriptConfigurationSmartGuideFadeOut {
  /** フラグ */
  enable: boolean
  /** 期間 */
  duration: number
}
